import moment from 'moment'
import mixins from '@/mixins'
const addCommasDecimal =  mixins.methods.addCommasDecimal

export default {
    title:{
      text:'Delta',
      floating:true,
      align:'left',
      y:15,
      style:{ 
        "color": "#667091", 
        "fontSize": "16px"
      }
    },
    chart:{
      backgroundColor:'transparent',
      height:250,
      zoomType:'x',
      resetZoomButton: {
        theme: {
            fill: 'white',
            stroke: '#41739D',
            style:{
              color:'#41739D',
            },
            r: 5,
            states: {
                hover: {
                    fill: '#41739D',
                    style: {
                        color: 'white'
                    }
                }
            }
        }
      }
    },
    legend:{
      itemStyle:{
        color: "#667091"
      },
      itemHoverStyle:{
        color: "#000000"
      }
    },
    xAxis: {
      type: 'datetime',
      lineColor: '#DDD9F9',
      tickColor: '#DDD9F9',
      labels: {
        style:{
          color: '#667091',
          fontSize:'12px'
        }
      },
      events: {}
    },
    yAxis: {
      // min:-1200,
      // max: 1200,
      reversed:true,
      labels: {
        style:{
          color: '#667091',
          fontSize:'12px'
        }
      },
      gridLineColor:'#DDD9F9',
      opposite:true,
      title: null,
      tickInterval:600,
      plotBands:[
        {
        from: -800,
        to: 800,
        color: 'rgba(204,223,255,0.3)'
        }
      ],
      plotLines:[
        {
        value: -800,
        dashStyle: 'ShortDash',
        width: 2,
        color: '#667091',
        },
        {
        value: 800,
        dashStyle: 'ShortDash',
        width: 2,
        color: '#667091',
        }
      ]
    },
    tooltip:{
      borderColor:'#DDD9F9',
      backgroundColor:'rgba(250,250,255,0.8)',
      style:{
        color:'#667091'
      },
      formatter(){
        return `<div>
          <strong>${moment(this.x).utc().format('dddd, MMM DD, HH:mm')}</strong><br>
          ${this.series.name}<br>
          High: ${addCommasDecimal(this.point.high)}<br>
          Low: ${addCommasDecimal(this.point.low)}
        </div>`;
      }
    },
    plotOptions:{
      line:{
        marker:{
          enabled:false,
          symbol: 'circle'
        }
      }
    },
    series: [
      {
        type:'columnrange',
        borderColor:'transparent',
        name:'ITM',
        data: [],
      },
      {
        type:'columnrange',
        borderColor:'transparent',
        name:'OTM',
        data: [],
        color:'#2f29b6'
      }]
}